import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../../utility/customAxios';
import { queryClient } from '../../queryClient';
import { queryKeys } from '../../queryKeys';

export const postRefreshGoogleAuth = async () => {
  const response = await CustomAxios.post(`integrations/google/refresh`);
  const { data } = response;
  return data;
};

export function useRefreshGoogleAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: postRefreshGoogleAuth,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.organizationIntegrations],
      });
    },
    onError: (err: unknown) => {
      if (err instanceof Error) {
        if (err.message === 'GOOGLE_AUTH_MISSING' || err.message === 'GOOGLE_AUTH_TOKEN_EXPIRED') {
          navigate('/oauth2redirect-google');
        }
      }
    },
  });
}
